@if (!hidePage()) {
  <header class="w-full header-bg">
    <div class="px-3 md:px-8 py-4 w-full">
      <div class="flex justify-between items-center w-full gap-2">
        <!-- Logo/Title -->

        <div class="flex items-center">
          <img src="assets/images/joiistudies-orange.png" alt="Joii Studies" class="h-10 w-auto object-scale-down" />
        </div>
        <!-- Logout Link -->
        <div class="flex flex-col xs:flex-row gap-3 md:gap-6 text-#070b12 text-sm font-medium text-center md:text-left">
          @if (chatDataStore.latestIncompleteChat()) {
            <button (click)="joinChat()">
              <joii-status-badge [icon]="messageCircleHeart" size="sm" content="Chat in progress"></joii-status-badge>
            </button>
          }
          @if (appUpdate.manualUpdateRequired()) {
            <button joii-inline-button variant="secondary" (click)="appUpdate.applyNow()" size="sm">Update app</button>
          }
          @if (trialId()) {
            <button joii-inline-button variant="secondary" (click)="reportIssue()" size="sm">Report an issue</button>
          }
          <button joii-inline-button variant="secondary" (click)="logout()" size="sm">Logout</button>
        </div>
      </div>
    </div>
  </header>
}
